/**
 * @hidden
 */
export var isAuthor = function isAuthor(user, msg) {
  return user && msg.author && user.id === msg.author.id;
};